import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { DealStatusPageInterface } from '@zaoblako/shared/modules/business/dto/deal-status/deal-status-page.dto';
import type { DealStatusFindManyQueryInterface } from '@zaoblako/shared/modules/business/dto/deal-status/deal-status-find-many-query.dto';
import type { DealStatusFindInterface } from '@zaoblako/shared/modules/business/dto/deal-status/deal-status-find.dto';

import { Injectable } from '@angular/core';
import { concatMap, type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DealStatusService extends BaseService {
  protected baseUrl = '/finance/business/deal-status';

  public restoreOne(id: number): Observable<DealStatusFindInterface> {
    return this.http.post<DealStatusFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findWithPagination(
    params?: DealStatusFindManyQueryInterface,
    descriptor?: ReportDescriptorInterface
  ): Observable<DealStatusPageInterface> {
    if (descriptor?.subroutes?.items) {
      return this.http.get<DealStatusPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
        params: params
          ? this.objectToHttpParams(params)
          : {}
      });
    } else {
      return this
        .getReportDescriptor()
        .pipe(concatMap((descriptor) => this.http.get<DealStatusPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
          params: params
            ? this.objectToHttpParams(params)
            : {}
        })))
    }
  }
}
